import React from "react";
import { Typography } from "@mui/material";
import CustomDialog from "../CustomDialog";
import CustomButton from "../CustomButton";
import { COLORS } from "../../assets/theme";

interface ClassBookingModePromptDialogProps {
  open: boolean;
  className?: string;
  submitting?: boolean;
  onClose: () => void;
  onBookOnce: () => void;
  onEnrollSeries: () => void;
}

/**
 * A BOTH-mode class allows drop-in and fixed-roster booking at once, so
 * adding a client from the roster panel is ambiguous — ask instead of
 * guessing. FIXED_ROSTER/DROP_IN-only classes never show this, since only
 * one of the two paths is even valid for them.
 *
 * "A block" rather than "the series": an open-ended class has no series length
 * to sell, so enrollment buys a chosen number of sessions instead.
 */
const ClassBookingModePromptDialog: React.FC<ClassBookingModePromptDialogProps> = ({
  open,
  className,
  submitting = false,
  onClose,
  onBookOnce,
  onEnrollSeries,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={() => {
        if (!submitting) onClose();
      }}
      title="Book this session, or a block of them?"
      actions={
        <>
          <CustomButton
            label="Cancel"
            variant="outlined"
            onClick={onClose}
            disabled={submitting}
          />
          <CustomButton
            label="Buy A Block"
            variant="outlined"
            onClick={onEnrollSeries}
            loading={submitting}
            disabled={submitting}
          />
          <CustomButton
            label="Just This Session"
            variant="contained"
            bgColor={COLORS.MainColor}
            textColor={COLORS.WhiteText}
            disabled={submitting}
            onClick={onBookOnce}
          />
        </>
      }
    >
      <Typography sx={{ fontSize: 14 }}>
        {`${className || "This class"} supports both drop-in and block enrollment. Book them into just this session, or sell them a block of upcoming sessions?`}
      </Typography>
    </CustomDialog>
  );
};

export default ClassBookingModePromptDialog;
